// extracted by mini-css-extract-plugin
export default {"app":"App_app__2CiNV","white_bg":"App_white_bg__Ma0do"};